import React from 'react';

function Minus({ width }) {
  return (
    <svg width={width || '18'} viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask044_g"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="8"
        width="14"
        height="3"
      >
        <path d="M16 10.2271H10H8H2V8.22705H8H10H16V10.2271Z" fill="white" />
      </mask>
      <g mask="url(#mask044_g)">
        <path d="M16 10.2271H10H8H2V8.22705H8H10H16V10.2271Z" fill="currentColor" />
      </g>
    </svg>
  );
}

export default Minus;
